
import React from "react";
import { Bell, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";

interface DashboardHeaderProps {
  userName: string;
  fullName: string;
  email: string;
}

export const DashboardHeader = ({ userName, fullName, email }: DashboardHeaderProps) => {
  return (
    <div className="flex justify-between items-center px-6 py-4 border-b border-gray-800 bg-gradient-to-r from-[#121212] to-[#1a1a1a]">
      <div>
        <h1 className="text-2xl font-semibold flex items-center gap-2">
          <ShieldCheck className="text-[#3D6D77] h-6 w-6" />
          Admin-Portal <span className="text-[#3D6D77] ml-2">{userName}</span>
        </h1>
        <p className="text-gray-400 text-sm mt-1">System Administration Panel</p>
      </div>
      
      <div className="flex items-center gap-4">
        <Button variant="default" className="bg-[#3D6D77] hover:bg-[#326670] text-white">
          System Status
        </Button>
        
        <div className="relative">
          <Bell className="w-6 h-6 cursor-pointer" />
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#3D6D77] rounded-full text-xs flex items-center justify-center">
            4
          </span>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="font-medium">{fullName}</p>
            <p className="text-sm text-gray-400">{email}</p>
          </div>
          <div className="w-10 h-10 rounded-full overflow-hidden bg-[#3D6D77] flex items-center justify-center text-white border border-[#3D6D77]/50">
            A
          </div>
        </div>
      </div>
    </div>
  );
};
